module.exports = __webpack_public_path__ + "img/SAS_MetalKiteShield.fcd76ffa.png";